import React, { useState } from "react";
import SurveysT from "../../Components/tabs/SurveysTabs/SurveysT";
import Feedback from "../../Components/tabs/SurveysTabs/Feedback";
import NcAssesment from "../../Components/tabs/SurveysTabs/NcAssesment";
import SNE from "../../Components/tabs/SurveysTabs/SNE";
import TeacherObservation from "../../Components/tabs/SurveysTabs/TeacherObservation";
import { ClipboardList, MessageSquare, Brain, Users, School } from 'lucide-react';

function Surveys() {
  const tabs = [
    {
      name: "Surveys",
      icon: <ClipboardList className="w-5 h-5" />
    },
    {
      name: "Feedbacks/Complaints",
      icon: <MessageSquare className="w-5 h-5" />
    },
    {
      name: "Neuro Cognitive Assessment",
      icon: <Brain className="w-5 h-5" />
    },
    {
      name: "SNE Surveys With Parents",
      icon: <Users className="w-5 h-5" />
    },
    {
      name: "Teachers ClassRoom Observations",
      icon: <School className="w-5 h-5" />
    }
  ];

  const [activeTab, setActiveTab] = useState("Surveys");
  const [surveys, setSurveys] = useState([]);
  const [ncCognitive, setNcCognitive] = useState([]);
  const [sNE, setSNE] = useState([]);
  const [feeBills, setFeeBills] = useState([]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="container mx-auto p-4 border border-[#241763]">
      {/* Tabs */}
      <div className="flex flex-wrap gap-2 border-2 border-gray-100 shadow-xl mb-4 p-3 rounded-b-xl">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => handleTabClick(tab.name)}
            className={`flex items-center gap-2 px-4 py-2 mt-2 ${
              activeTab === tab.name 
                ? "text-white bg-[#241763]" 
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            } rounded-md transition-colors duration-200 md:text-base text-sm`}
          >
            {tab.icon}
            <span className="hidden sm:inline">{tab.name}</span>
            <span className="sm:hidden">{tab.name.split(' ')[0]}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === "Surveys" && (
          <SurveysT
            surveys={surveys}
            setSurveys={setSurveys}
          />
        )}

        {activeTab === "Feedbacks/Complaints" && (
          <Feedback feeBills={feeBills} setFeeBills={setFeeBills} />
        )}

        {activeTab === "Neuro Cognitive Assessment" && (
          <NcAssesment
            ncCognitive={ncCognitive}
            setNcCognitive={setNcCognitive}  
          />
        )}

        {activeTab === "SNE Surveys With Parents" && (
          <SNE
            sNE={sNE}
            setSNE={setSNE}
          />
        )}
        
        {activeTab === "Teachers ClassRoom Observations" && (
          <TeacherObservation/>
        )}
      </div>
    </div>
  );
}

export default Surveys;
